/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import { getCurrentUser } from 'state/current-user/selectors';
import { Stack } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import Card from 'components/card';
import DateTime from 'components/date-time';

const SupportDetailsCard = ({ supportType, supportExpiry, additionalLicenses }) => {
	return (
		<Card>
			<Stack>
				<Card.Section>
					<DetailListItem label='Support expiry date' detail={<DateTime date={supportExpiry} format='Do MMM, YYYY' />} />
				</Card.Section>
				<Card.Section>
					<DetailListItem label='Additional stores' detail={additionalLicenses} />
				</Card.Section>
			</Stack>
		</Card>
	);
};

export default connect((state) => {
	let user = getCurrentUser(state);
	return {
		supportType: user && user.supportType,
		additionalLicenses: user && user.additionalLicenses,
		supportExpiry: user && user.sugarSupportExpiry,
	};
}, {})(SupportDetailsCard);
